import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonInput } from '@ionic/vue'
import { useAttrs } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicNormalInput',
  setup(__props) {

const attrs = useAttrs()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonInput), _normalizeProps(_guardReactiveProps(_unref(attrs))), null, 16))
}
}

})